var exports = {
  "P": "SanitizedHtml__OlVJg_",
};

module.exports = exports;
